import { render } from "./Player.vue?vue&type=template&id=3638713c&scoped=true"
import script from "./Player.vue?vue&type=script&lang=js"
export * from "./Player.vue?vue&type=script&lang=js"

import "./Player.vue?vue&type=style&index=0&id=3638713c&scoped=true&lang=css"

import exportComponent from "/go/src/asuzs/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3638713c"]])

export default __exports__